import React from 'react'
import About from './About'
import image1 from '../images/Frame 19.png'


function AboutComponent() {
    return (
        <div>
            <About image={image1} title="Come with All You Need for Daily Life"/>

        </div>
    )
}


export default AboutComponent


